import React from 'react';
import { WrapperFlex, Button } from '@unimed-fesp/components';

import { ContentText } from './styles';

const BodyConfimarRelatorio = () => {
  return (
    <ContentText>
      <strong>Caso já exista um relatório, o mesmo será excluído!</strong>
      <br />
      A geração deste novo relatório pode demorar. Não há necessidade de
      permanecer na tela, pois será notificado por e-mail.
      <br />
      Deseja continuar a geração do relatório?
    </ContentText>
  );
};

const FooterConfimarRelatorio = ({ closeModal, onClickOk }) => {
  return (
    <WrapperFlex justifySpaceAround minWidth={250}>
      <Button tipo="secondary" onClick={closeModal} width={100} justifyCenter>
        não
      </Button>
      <Button onClick={onClickOk} width={100} justifyCenter>
        sim
      </Button>
    </WrapperFlex>
  );
};

export default { BodyConfimarRelatorio, FooterConfimarRelatorio };
